import { render, staticRenderFns } from "./NHIADashboard.vue?vue&type=template&id=a1258fca&scoped=true&"
import script from "./NHIADashboard.vue?vue&type=script&lang=js&"
export * from "./NHIADashboard.vue?vue&type=script&lang=js&"
import style0 from "./NHIADashboard.vue?vue&type=style&index=0&id=a1258fca&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1258fca",
  null
  
)

export default component.exports